import React from 'react';
import { Badge, Tab, Tabs } from '@mui/material';
import { ExecutiveReviewTabCode } from './executiveReview.models';
type Props = {
  value: ExecutiveReviewTabCode;
  blockingcount: number;
  onChange: (v: ExecutiveReviewTabCode) => void;
};
class ExecutiveReviewTabs extends React.PureComponent<Props> {
  render() {
    return (
      <Tabs
        value={this.props.value}
        onChange={(_, v) => this.props.onChange(v)}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab value="summary" label="Executive Summary" />
        <Tab value="comparison" label="Scenario Comparison" />
        <Tab value="capacity" label="Financial Capacity" />
        <Tab value="risk" label="Sensitivity & Risk" />
        <Tab
          value="recommendation"
          label={
            <Badge color="error" badgeContent={this.props.blockingcount}>
              Recommendation
            </Badge>
          }
        />
        <Tab value="history" label="Decision History" />
      </Tabs>
    );
  }
}
export default ExecutiveReviewTabs;
